import React, { useState, useEffect } from 'react';
import { 
  Search, Filter, Grid3X3, List, BarChart3, Plus, 
  Eye, Edit, MoreVertical, Clock, AlertCircle, 
  CheckCircle, Calendar, Phone, User, DollarSign,
  FileText, Briefcase, BookOpen, Calculator, PenTool,
  ClipboardCheck, Archive, RefreshCw, Hourglass,
  CheckSquare, X, Save, Upload, Users
} from 'lucide-react';
import { useFormOptions } from '../../../config/constants';
import Select, { components } from 'react-select';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import ContenidoEnriquecido from '../../../components/ContenidoEnriquecido';
import { useSolicitudesDisponiblesModel } from '../../../modelos/Solicitudes/modeloSolicitudes';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud';

const NuevaTesis = ({ isOpen, onClose, onSubmit, isLoading = false }) => {
  const [formData, setFormData] = useState({
    servicio: '',
    materia: '',
    cliente: '',
    fechaentrega: '',
    resumen: '',
    //objetoFaltente.formatoEntrega: '',
    contenidoEnriquecido: '',
    //fecha sistema en servidor    
  });
  const [errors, setErrors] = useState({});
  const {tipoServiciosOptions } = useFormOptions();
  const {
      materiasOptions,
      cargarMaterias,
      cargarClientes,
      clientesOptions,
    } = useListasModel();
  const resetForm = () => {
    setFormData({
      servicio: '',
      materia: '',
      cliente: '',
      fechaentrega: '',
      resumen: '',
      //objetoFaltente.formatoEntrega: '',
      contenidoEnriquecido: '',
      //fecha sistema en servidor
    });
    setErrors({});
  };
  const {
    addNewSolicitud
  } = useDetalleSolicitudModel();

  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  //cargar materias
  useEffect(() => {
      cargarMaterias();
    }, []);


  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("tenemos para enviar",formData);
    addNewSolicitud('DUFO',formData);
    /*
    // Combinar fecha y hora
      
    const solicitudData = {
      ...formData,
      fechaentrega: fechaCompleta,
    };
      
    onSubmit(solicitudData);
    */

  };

   const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  const handleSelectChange = (selectedOption, { name }) => {
  setFormData({
    ...formData,
    [name]: selectedOption ? selectedOption.value : ''
  });
  
  // Limpiar error si existe
  if (errors[name]) {
    setErrors({
      ...errors,
      [name]: ''
    });
  }
};

const handleSaveContenido = async (nuevoContenido) => {
  try {
    console.log('Guardando contenido:', nuevoContenido);
    
    // Actualizar el formData local
    setFormData(prev => ({
      ...prev,
      contenidoEnriquecido: nuevoContenido
    }));
    
    // Si tienes una función para guardar en el servidor, úsala aquí:
    // await onSubmit({ ...formData, contenidoEnriquecido: nuevoContenido });
    
    console.log('Contenido guardado exitosamente');
  } catch (error) {
    console.error('Error al guardar contenido:', error);
    throw error;
  }
};


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Nueva Solicitud de Servicio</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Información del Servicio */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Briefcase size={20} />
              Información del Servicio
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de Servicio *
                </label>
                
                <Select
                  name="servicio"
                  value={getOptionFromValue(tipoServiciosOptions, formData.servicio)}
                  onChange={handleSelectChange}
                  options={tipoServiciosOptions}
                  placeholder="Selecciona tu tipo de servicio"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                  required
                />

                {errors.servicio && <p className="text-red-500 text-sm mt-1">{errors.servicio}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Materia *
                </label>
               
               <Select
                  name="materia"
                  value={getOptionFromValue(materiasOptions, formData.materia)}
                  onChange={handleSelectChange}
                  options={materiasOptions}
                  placeholder="Selecciona tu tipo de servicio"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                  required
                />

                {errors.materia && <p className="text-red-500 text-sm mt-1">{errors.materia}</p>}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cliente *
              </label>
              
              <Select
                  name="cliente"
                  value={getOptionFromValue(clientesOptions, formData.cliente)}
                  onChange={handleSelectChange}
                  options={clientesOptions}
                  placeholder="Selecciona tu Cliente"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                  //required
                />

              
            </div>

            {/* Fecha y Hora de Entrega */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Calendar size={20} />
              Fecha y Hora de Entrega
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fecha de Entrega *
                </label>
                 <input
                    type="datetime-local"
                    value={formData.fechaentrega} // Ahora solo necesitas un campo
                    onChange={(e) => setFormData({...formData, fechaentrega: e.target.value})}
                    min={new Date(Date.now()).toISOString().slice(0, 16)} // Mínimo 1 minuto desde ahora
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      errors.fechaentrega ? 'border-red-500' : 'border-gray-300'
                    }`}
                    required
                  />
                {errors.fechaentrega && <p className="text-red-500 text-sm mt-1">{errors.fechaentrega}</p>}
              </div>

              
            </div>
          </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Resumen del Trabajo *
              </label>
              <input
                type="text"
                value={formData.resumen}
                onChange={(e) => setFormData({...formData, resumen: e.target.value})}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.resumen ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Breve descripción del trabajo a realizar"
                maxLength={100}
                required
              />
              <div className="flex justify-between items-center mt-1">
                {errors.resumen && <p className="text-red-500 text-sm">{errors.resumen}</p>}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Descripción Detallada *
              </label>
              {/* Aqui viene el contenido Enriquecido */}
               <div className="mb-6">
                  <ContenidoEnriquecido 
                    contenido={formData.contenidoEnriquecido} 
                    isAdmin = {true}
                    editable={true}
                    onSave={handleSaveContenido} 
                  />
                
               </div>

              {errors.descripcionDetallada && <p className="text-red-500 text-sm mt-1">{errors.descripcionDetallada}</p>}
            </div>
          </div>

          {/* Botones */}
          <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-100 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Cancelar
            </button>
            {/* Boton de crear solicitud */}
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Creando...
                </>
              ) : (
                <>
                  <Save size={16} />
                  Crear Solicitud
                </>
              )}
            </button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default NuevaTesis;
